import { hasRequiredListItemFields } from "../../../../../modules/PrimaryProductInfo/ProductDetailSpecification/types.js";
const getCategorySpecificationListItems = (categories) => {
  const parentCategories = [];
  for (const category of categories) {
    if (!category.ancestors || category.ancestors.length === 0) continue;
    const parentCategory = category.ancestors[0];
    const childCategory = category.ancestors.length > 1 ? category.ancestors[1] : category;
    if (!parentCategory || !childCategory) {
      continue;
    }
    if (!hasRequiredListItemFields(parentCategory) || !hasRequiredListItemFields(childCategory))
      continue;
    const existingParentCategory = parentCategories.find(
      (category2) => category2.key === parentCategory.key
    );
    const existingChildCategory = existingParentCategory?.children.find(
      (child) => child.key === childCategory.key
    );
    if (!existingParentCategory) {
      parentCategories.push({ ...parentCategory, children: [childCategory] });
    } else if (!existingChildCategory) {
      existingParentCategory.children.push(childCategory);
    }
  }
  const specificationListItems = parentCategories.map((category) => ({
    key: category.key,
    label: category.name,
    value: category.children.map((child) => child.name).join(", ")
  }));
  return specificationListItems.slice(0, 6);
};
export {
  getCategorySpecificationListItems
};
//# sourceMappingURL=get-category-specification-list-items.js.map
